// import Swiper JS
import Swiper from 'swiper';
// import Swiper styles

(function ($) {

    
    if($('.buttons-carousel-column').length > 0) {
        $('.buttons-carousel-column').each(function(){
            $(this).find('.elementor-widget-wrap').first().addClass('buttons-carousel');
            $(this).find('.elementor-widget-button').addClass('button')
        })
    }

    if($('.buttons-carousel').length > 0) {
        let i = 0;
        $('.buttons-carousel').each(function(){
            let html = $(this).html();
            $(this).html('<div class="swiper-buttons-'+ i +'"><div class="swiper-wrapper">'+ html +'</div></div>');
            $(this).find('.button').addClass('swiper-slide');
            const swiper = new Swiper('.buttons-carousel .swiper-buttons-'+ i, {
                //grabCursor: true,
                slidesPerView: "auto",
                resistanceRatio: 0
            });
            
            let eq = $(this).find('.active').index('.swiper-buttons-'+ i +' .button')
            swiper.slideTo(eq);

            i++;
        });
    } 

})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partials/sliders/buttons-carousel.js